// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__GPcPD","title":"Header_title__1Dsbj","left":"Header_left__1VNHE","clinicName":"Header_clinicName__1_aBk"};